<template>
  <div class="page-wechat-code-helper"></div>
</template>
<script>
import { OPEN_ID_KEY } from '../../utils/pay';
import { getRequest } from '../../utils/string';
import { Api, Codes } from '../../api';
export default {
  name: 'WeChatCodeHelper',
  data: () => ({
    wxCode: ''
  }),
  mounted: async function() {
    let query = getRequest();
    let redirectUrl = decodeURIComponent(query.r);
    let code = query.code;
    let res = await Api.post.postPaymentWechatAuthorize({
      code: code
    });
    if (res.status === Codes.SUCCESS) {
      let openId = res.data.wechat_pay_openid;
      localStorage.setItem(OPEN_ID_KEY, openId);
    }
    if (redirectUrl.indexOf('?') > -1) {
      window.location.href = redirectUrl + '&wxmp=true';
    } else {
      window.location.href = redirectUrl + '?wxmp=true';
    }
  }
};
</script>
